import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrokerWidgetContext } from './NewbuildingBrokerWidgetContext';
import { useNewbuildingBrokerWidgetAPI } from './useNewbuildingBrokerWidgetAPI';
import { BROKER_WIDGET_MANIFEST_CONFIG_KEY } from '../../constants/config';
import { selectIsBrokerAvailability } from '../../selectors/brokerAvailability';
import { useApplicationContext } from '../../utils/applicationContext';

export const NewbuildingBrokerWidgetProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const isBrokerAvailability = useSelector(selectIsBrokerAvailability);

  const { config } = useApplicationContext();
  const widgetManifest = config.get<IMicrofrontendManifest>(BROKER_WIDGET_MANIFEST_CONFIG_KEY);

  const isWidgetManifestLoaded = Boolean(widgetManifest);

  const { openWidget, widgetRef } = useNewbuildingBrokerWidgetAPI();

  const contextValue = React.useMemo(
    () => ({
      isBrokerAvailable: isBrokerAvailability && isWidgetManifestLoaded,
      openWidget,
    }),
    [isBrokerAvailability, isWidgetManifestLoaded, openWidget],
  );

  return (
    <NewbuildingBrokerWidgetContext.Provider value={contextValue}>
      {children}
      {widgetManifest && (
        <Microfrontend
          ref={widgetRef}
          name={widgetManifest.microfrontendName}
          image={widgetManifest.imageVersion}
          runtime={widgetManifest.runtimeName}
          instance={widgetManifest.instanceId}
        />
      )}
    </NewbuildingBrokerWidgetContext.Provider>
  );
};
